export var FinalidadeDeclaracaoEnum;
(function (FinalidadeDeclaracaoEnum) {
    FinalidadeDeclaracaoEnum["SEFAZ"] = "SEFAZ";
    FinalidadeDeclaracaoEnum["OCUPACAO_CREDITO"] = "OCUPACAO_CREDITO";
    FinalidadeDeclaracaoEnum["INSS"] = "INSS";
})(FinalidadeDeclaracaoEnum || (FinalidadeDeclaracaoEnum = {}));
(function (FinalidadeDeclaracaoEnum) {
    var mapDescricao = new Map([
        [FinalidadeDeclaracaoEnum.SEFAZ, 'Inscrição Estadual - SEFAZ'],
        [FinalidadeDeclaracaoEnum.OCUPACAO_CREDITO, 'Ocupação - Crédito'],
        [FinalidadeDeclaracaoEnum.INSS, 'Aposentadoria - INSS'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    FinalidadeDeclaracaoEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    FinalidadeDeclaracaoEnum.getOptions = getOptions;
})(FinalidadeDeclaracaoEnum || (FinalidadeDeclaracaoEnum = {}));
